export default {"src":"/_next/static/media/hero_m.558c0cea.svg","height":291,"width":211,"blurWidth":0,"blurHeight":0};